import type { Point2d } from "."
import { rotatePoint } from "./rotatePoint"
import type { Panel } from "../design"

type ReorientationOptions = {
  panel: Panel
  origin: Point2d
  addedRotation: number
  azimuth: number
}

export const getReorientedPanel = ({
  origin,
  panel,
  addedRotation,
  azimuth,
}: ReorientationOptions): Panel => {
  const totalOrientation = (panel?.orientation ?? 0) + addedRotation
  const newPanelRotation = (Math.round(azimuth) + totalOrientation) % 360
  const previousRotation = panel.r + (panel?.orientation ?? 0)
  const degrees = newPanelRotation - panel.r

  const rotationDidChange =
    (previousRotation !== newPanelRotation && degrees !== 0) || addedRotation

  const newOrientation =
    addedRotation !== 0
      ? azimuth !== 0
        ? totalOrientation % 360
        : newPanelRotation
      : panel?.orientation ?? 0

  return rotationDidChange
    ? {
        ...panel,
        r: newPanelRotation,
        orientation: newOrientation,
        ...rotatePoint(origin, panel, degrees % 360),
      }
    : panel
}
